import { Component } from '@angular/core';
import { Events, ModalController } from 'ionic-angular';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';

const DEFAULTVALUE = 0;
@Component({
  selector: 'cloud-pricing-sheet',
  templateUrl: 'cloud-pricing-sheet.html'
})
export class CloudPricingSheetComponent {
  showMonth: boolean = false;
  discountMonths = [{
    "period": "For 3 Months until",
    "value": '3'
  }, {
    "period": "For 6 Months until",
    "value": '6'
  }, {
    "period": "For 9 Months until",
    "value": '9'
  }, {
    "period": "For 12 Months until",
    "value": '12'
  }, {
    "period": "For 18 Months until",
    "value": '18'
  }, {
    "period": "For 24 Months until",
    "value": '24'
  }, {
    "period": "For 36 Months until",
    "value": '36'
  }, {
    "period": "For 48 Months until",
    "value": '48'
  }, {
    "period": "For 60 Months until",
    "value": '60'
  }, {
    "period": "until changed",
    "value": ''
  }];
  months=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  DateDefault: any = new Date();
  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'return'
    }, 
    {
      "name": "azure ws",
      "action": 'azureWs'
    },
    {
      "name": "price list",
      "action": 'priceList'
    },{
      "name": "preview",
      "action": 'preview'
    }]
  };
  AzureStatus: any = 'N';
  constructor(public dataService: DataServiceProvider,public modalCtrl: ModalController,public exportService: ExportServiceProvider, public event: Events,public priceListTableService: PriceListTableProvider) {
  }

  ngOnInit(){
    this.dataService.goBack = 'CLD';
    this.dataService.sheetName = 'CLD';
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    if (localStorage.getItem('MSPForm')) {
      let mspFormValues = JSON.parse(localStorage.getItem('MSPForm'));
      this.dataService.ProposalTable.mspForm.noOfUsers = mspFormValues.noOfUsers != '' ? mspFormValues.noOfUsers : this.dataService.ProposalTable.mspForm.noOfUsers;
      this.DateDefault = mspFormValues.startDate != '' ? new Date(mspFormValues.startDate) : new Date();
    }
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if(priceListData != null){
      this.priceListTableService.priceList.TotalLabourRegularRate = priceListData.defLabourRegularRate;
      this.priceListTableService.priceList.CloudServerAndSW.server.SellValue =  priceListData.CloudServerAndSW.server.SellValue;
      this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue =  priceListData.CloudServerAndSW.cpu.SellValue;
      this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue =  priceListData.CloudServerAndSW.ram.SellValue;
      this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue =  priceListData.CloudServerAndSW.disk.SellValue;
      this.priceListTableService.priceList.TotalToolsMarkup = priceListData.TotalToolsMarkup;
      this.priceListTableService.priceList.CloudServerAndSW.SWItem = priceListData.CloudServerAndSW.SWItem;
    }else{
      this.priceListTableService.priceList.TotalToolsMarkup = this.priceListTableService.priceList.defToolsMarkup;
      this.priceListTableService.priceList.TotalLabourRegularRate = this.priceListTableService.priceList.defLabourRegularRate;
      if (this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn != '') {
        var diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      } else {
        // diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.defCostCdn.slice(1)) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        diskVal = (0.285714285714286) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      }
      if (this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn != '') {
        var ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      } else {
        // ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.defCostCdn.slice(1)) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        ramVal = (3.62857142857143) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      }
      if (this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn != '') {
        var cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      } else {
        // cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.defCostCdn.slice(1)) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        cpuVal = (8.92857142857143) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      }
      if (this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn != '') {
        var serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      } else {
        // serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.defCostCdn.slice(1)) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        serverVal = (60.7142857142857) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
      }
      this.priceListTableService.priceList.CloudServerAndSW.server.SellValue =  '$' + serverVal.toFixed(2);
      this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue =  '$' + cpuVal.toFixed(2);
      this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue = '$' + ramVal.toFixed(2);
      this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue =  '$' + diskVal.toFixed(2);
      this.priceListTableService.priceList.CloudServerAndSW.SWItem.forEach(element => {
        if(element.defCostCdn != ''){
        if (element.newCostCdn != '') {
          var newVal = parseFloat(element.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((element.orPercent != '' ? element.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        } else {
          newVal = parseFloat(element.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((element.orPercent != '' ? element.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        }
        element.SellValue =  '$' + newVal.toFixed(2);
      }
      });
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlySelectedMonth == ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlySelectedMonth = 'until changed';
    }
    if(localStorage.getItem('CLOUDScreenData')){
      this.dataService.ProposalTable.cloudPricingSheet = JSON.parse(localStorage.getItem('CLOUDScreenData'));
      if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount != ''){
        this.showMonth = true;
      }
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureMonthly != ''){
      this.AzureStatus = 'Y';
      this.TotalMiscellaneous();
    }
    this.bindHeaderValues();
  }

  OnSetupConfigHours(event) {
    if (event.target.value != '') {
      this.dataService.ProposalTable.cloudPricingSheet.SetupConfigHours = parseFloat(event.target.value).toFixed(1);
      let val = parseFloat(event.target.value) * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,""));
        this.dataService.ProposalTable.cloudPricingSheet.SetupConfigOneTime = '$' + val.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.cloudPricingSheet.SetupConfigHours = '';
      this.dataService.ProposalTable.cloudPricingSheet.SetupConfigOneTime = '';
    }
    this.TotalStartUpFees();
  }
  OnCourtesyDiscountHours(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        let val = event.target.value.slice(1).replace(/  |,/gi,"");
        this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountHours = '$' + parseFloat(val).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountHours = '$'.concat(parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
      }
      this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountOneTime = this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountHours
    } else {
      this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountOneTime = '';
      this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountHours = '';
    }
    this.TotalStartUpFees();
  }
  TotalStartUpFees() {
    if (this.dataService.ProposalTable.cloudPricingSheet.SetupConfigOneTime != "") {
      var setupConfigTotal = parseFloat(this.dataService.ProposalTable.cloudPricingSheet.SetupConfigOneTime.slice(1).replace(/  |,/gi,""));
    } else {
      var setupConfigTotal = DEFAULTVALUE;
    }
    if (this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountOneTime != '') {
      var CourtesyDiscountTotal = parseFloat(this.dataService.ProposalTable.cloudPricingSheet.CourtesyDiscountOneTime.slice(1).replace(/  |,/gi,""));
    } else {
      var CourtesyDiscountTotal = DEFAULTVALUE;
    }
    let TotalVal = setupConfigTotal - CourtesyDiscountTotal;
    if(TotalVal != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.TotalStartUp = '$' + TotalVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.TotalStartUp = ''
    }
    this.bindHeaderValues();
  }
  hoursPerMonth(event){
    if (event.target.value != '') {
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.hours = parseFloat(event.target.value).toFixed(1);
      let val = parseFloat(event.target.value) * parseFloat(this.priceListTableService.priceList.TotalLabourRegularRate.slice(1).replace(/  |,/gi,""));
        this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.oneTime = '$' + val.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else {
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.hours = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.oneTime = '';
    }
    this.TotalMiscellaneous();
  }
  serverName(event,i){
    if(event.target.value != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].serverName = event.target.value;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].base = this.priceListTableService.priceList.CloudServerAndSW.server.SellValue;
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].serverName = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].base = '';
    }
    this.TotalIaas(i);
    this.TotalBase();
  }
  cpuQty(event,i){
    if(event.target.value != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuQty = event.target.value;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuPrice = this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuSubTtl = '$' + (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuQty) * parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuQty = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuPrice = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuSubTtl = '';
    }
    this.TotalIaas(i);
    this.TotalCpu();
  }
  ramQty(event,i){
    if(event.target.value != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramQty = event.target.value;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramPrice = this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramSubTtl = '$' + (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramQty) * parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramQty = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramPrice = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramSubTtl = '';
    }
    this.TotalIaas(i);
    this.TotalRam();
  }
  diskQty(event,i){
    if(event.target.value != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskQty = event.target.value;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskPrice = this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskSubTtl = '$' + (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskQty) * parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskPrice.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskQty = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskPrice = '';
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskSubTtl = '';
    }
    this.TotalIaas(i);
    this.TotalDisk();
  }
  TotalIaas(i){
    let sumArray = [];
    let baseVal = this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].base != '' ? parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].base.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
    let cpuVal = this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuSubTtl != '' ? parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].cpuSubTtl.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
    let ramVal = this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramSubTtl != '' ? parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].ramSubTtl.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
    let diskVal = this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskSubTtl != '' ? parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].diskSubTtl.slice(1).replace(/  |,/gi,"")) : DEFAULTVALUE;
    sumArray.push(baseVal,cpuVal,ramVal,diskVal);
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].Total = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS[i].Total = '';
    }
    this.SubtotalIaaS();
  }
  TotalBase(){
    let baseArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
      if(elem.base != ''){
        baseArray.push(parseFloat(elem.base.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = baseArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalBase = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalBase = '';
    }
  }
  TotalRam(){
    let ramArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
      if(elem.ramSubTtl != ''){
        ramArray.push(parseFloat(elem.ramSubTtl.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = ramArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalRam = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalRam = '';
    }
  }
  TotalCpu(){
    let cpuArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
      if(elem.cpuSubTtl != ''){
        cpuArray.push(parseFloat(elem.cpuSubTtl.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = cpuArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalCpu = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalCpu = '';
    }
  }
  TotalDisk(){
    let diskArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
      if(elem.diskSubTtl != ''){
        diskArray.push(parseFloat(elem.diskSubTtl.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = diskArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalDisk = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalDisk = '';
    }
  }
  SubtotalIaaS(){
    let totalArray = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.IaaS.forEach(elem => {
      if(elem.Total != ''){
        totalArray.push(parseFloat(elem.Total.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = totalArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubtotalIaaS = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubtotalIaaS = '';
    }
    this.TotalMiscellaneous();
  }
  SaaSItem(event,i){
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].item = event.target.value;
    if(event.target.value != ''){
      this.priceListTableService.priceList.CloudServerAndSW.SWItem.forEach(element => {
        if(element.item == this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].item){
          this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price = element.SellValue;
        }
      });
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price = '';
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].qty != '' && this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].total = '$' + (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].qty) * parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    this.SubtotalSaaS();
  }
  SaaSQty(event,i){
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].qty = event.target.value;
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].qty != '' && this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price != ''){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].total = '$' + (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].qty) * parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].price.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS[i].total = '';
    }
    this.SubtotalSaaS();
  }
  SubtotalSaaS(){
    var subTotal = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SaaS.forEach(elem=>{
      if(elem.total != ''){
        subTotal.push(parseFloat(elem.total.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = subTotal.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalSaaS = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalSaaS = '';
    }
    this.TotalMiscellaneous();
  }
  miscellaneousDescription(event,i){
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous[i].description = event.target.value;
  }
  miscellaneousTools(event,i){
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous[i].tools = event.target.value;
  }
  miscellaneousPrice(event,i){
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous[i].price = '$' + parseFloat(event.target.value.slice(1).replace(/  |,/gi,"")).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous[i].price = '$' + parseFloat(event.target.value).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    } else {
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous[i].price = '';
    }

    this.SubtotalMiscellaneous();
  }
  SubtotalMiscellaneous(){
    var subTotal = [];
    this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.miscellaneous.forEach(elem=>{
      if(elem.price != ''){
        subTotal.push(parseFloat(elem.price.slice(1).replace(/  |,/gi,"")));
      }
    });
    var value = subTotal.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous = '';
    }
    this.TotalMiscellaneous();
  }

  TotalMiscellaneous(){
    var totalMiscellaneousArray = [];
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous != ''){
      totalMiscellaneousArray.push(parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalMiscellaneous.slice(1).replace(/  |,/gi,"")));
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalSaaS != ''){
      totalMiscellaneousArray.push(parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubTotalSaaS.slice(1).replace(/  |,/gi,"")));
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubtotalIaaS != ''){
      totalMiscellaneousArray.push(parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.SubtotalIaaS.slice(1).replace(/  |,/gi,"")));
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.oneTime != ''){
      totalMiscellaneousArray.push(parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.oneTime.slice(1).replace(/  |,/gi,"")));
    }
    if(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureMonthly != ''){
      totalMiscellaneousArray.push(parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.AzureMonthly.slice(1).replace(/  |,/gi,"")));
    }
    var value = totalMiscellaneousArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring = '';
    }
    this.TotalDiscountMonth();
    this.FeeSummaryMonthly();
  }
  discountsForMonths(event){
    var startMonth = this.months[this.DateDefault.getMonth()];
    var startYear = this.DateDefault.getYear().toString().slice(-2);
    var startDate = this.DateDefault.getDate().toString().padStart(2, '0');
    var newDate = new Date(this.DateDefault);
    var valArr = '';
    this.discountMonths.forEach(elem=>{
      if(elem.period == event.target.value && elem.value != ''){
        valArr = elem.value;
      }
    })
    if(valArr != ''){
      newDate.setMonth(this.DateDefault.getMonth() + parseInt(valArr));
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.monthlyPeriod = this.months[newDate.getMonth()] + " 01 '" + newDate.getFullYear().toString().slice(-2) + ". Assumes start of " + startMonth +" " + startDate + " '" + startYear;
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.monthlyPeriod = '';
    }
    this.TotalDiscountMonth();
  }
  TotalDiscountMonth(){
    this.dataService.ProposalTable.cloudPricingSheet.DiscountMonth = 'Discount per Brian Everest ' + this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount + ' ' + this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlySelectedMonth + ' ' + this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.monthlyPeriod;
  }
  cloudMonthlyDiscount(event) {
    if (event.target.value != '') {
      if (event.target.value.includes("$") == true) {
        var backupDiscount = parseFloat(event.target.value.slice(1).replace(/  |,/gi,""));
      } else {
        backupDiscount = parseFloat(event.target.value);
      }
      this.showMonth = true;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount = '$' + backupDiscount.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.showMonth = false;
      this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount = '';
    }
    this.TotalDiscountMonth();
    this.FeeSummaryMonthly();
  }
  FeeSummaryMonthly(){
    let val = (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring != '' ? this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.TotalMonthlyRecurring.slice(1).replace(/  |,/gi,"") : '0'));
    let subVal = (parseFloat(this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount != '' ? this.dataService.ProposalTable.cloudPricingSheet.monthlyRecurring.cloudMonthlyTotalDiscount.slice(1).replace(/  |,/gi,"") : '0'));
    let toatlVal = (val - subVal);
    if(toatlVal != DEFAULTVALUE){
      this.dataService.ProposalTable.cloudPricingSheet.FeesummaryMonthlyTotal = '$' + toatlVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.FeesummaryMonthlyTotal = '';
    }
    this.bindHeaderValues();
  }
  ngAfterViewInit(){
        document.getElementById('pageWidth').scrollIntoView();
  }
  ngAfterViewChecked(){
    localStorage.setItem('CLOUDScreenData', JSON.stringify(this.dataService.ProposalTable.cloudPricingSheet));
  }
  ngOnDestroy() {
  }
  bindHeaderValues(){
    let obj = {
      "oneTime" : 'One time',
      "monthly" : 'Monthly',
      "monthlyValue":  this.dataService.ProposalTable.cloudPricingSheet.FeesummaryMonthlyTotal,
      "OneTimeValue": this.dataService.ProposalTable.cloudPricingSheet.TotalStartUp
    }
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: obj});
  }
}



// WEBPACK FOOTER //
// ./src/components/cloud-pricing-sheet/cloud-pricing-sheet.ts